import { render } from "./CourseContentLoader.vue?vue&type=template&id=345583c0"
import script from "./CourseContentLoader.vue?vue&type=script&lang=js"
export * from "./CourseContentLoader.vue?vue&type=script&lang=js"

import "./CourseContentLoader.vue?vue&type=style&index=0&id=345583c0&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__